export default __webpack_public_path__ + "8bad8c2a2e1f7a25f9c20957f2501d74.png";